module.exports = __webpack_public_path__ + "img/en.b7de6257.svg";